// On mount: this.keyBinder = new KeyBinder({cmdEnter: this.saveSchedule.bind(this)});
// On unmount: this.keyBinder.destroy()
export default class KeyBinder {
    constructor(keyBindings) {
        this.keyBindings = keyBindings;
        Object.keys(keyBindings).forEach(hotKey => {
            window.addEventListener(hotKey, keyBindings[hotKey], false);
        });
    }
    destroy() {
        Object.keys(this.keyBindings).forEach(hotKey => {
            window.removeEventListener(hotKey, this.keyBindings[hotKey]);
        });
    }
}


// WEBPACK FOOTER //
// ./app/utils/KeyBinder.js